module.exports = __webpack_public_path__ + "img/26.3c877eb5.jpg";